import React, { Component } from 'react';
import { func } from 'prop-types';

import cx from 'classnames';
import s from './SchedulingNotes.css';


export default class SchedulingNotes extends Component {
  static propTypes = {
    handleNotes: func,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  // Callback to pass notes up the parent chain to SchedulingContainer
  componentDidUpdate() {
    this.props.handleNotes(this.state.notes);
  }

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  render() {
    return (
      <section className={s.component}>
        <label className={s.hidden} htmlFor="notes">
          Include a message to your provider
        </label>
        <textarea
          className={cx(s.control, s.textarea)}
          onChange={this.handleChange}
          id="notes"
          name="notes"
          placeholder="Include a message to your provider..."
          value={this.state.value}
        />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Notes/SchedulingNotes.js